import styled from 'styled-components';

import {getRatingsColor} from '@stencil/hotels-utils/src/get-ratings-colors';

export const HotelReviewWrapper = styled.div`
  display: flex;
`;

export const ReviewWrapper = styled.div`
  border-radius: 8px;
  background-color: ${props => getRatingsColor(props?.hotelRating)};
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
`;

export const FlexBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AverageRating = styled.span`
  color: #fff;
  text-align: center;
  font-size: 22px;
  font-weight: 600;
`;

export const ReviewCountWrapper = styled.div`
  align-self: center;
  margin-left: 8px;
`;

export const ReviewSubText = styled.div`
  color: #647a97;
  font-size: 16px;
  font-weight: 400;
`;

export const ReviewCountText = styled.div`
  color: #000;
  font-size: 16px;
  font-weight: 600;
`;

export const ReviewCountTextWrapper = styled.p(
  props => `
    font-size: ${props.theme.font.custom(14)};
    align-items: center;
    padding-top: ${props.theme.spacing.small};
    padding-bottom: ${props.theme.spacing.small};
    font-weight: 500;
  `,
);
